
import React, { useState } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Edit, Save, X, Zap } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import AISettingsHeader from './AISettingsHeader';
import ModelsTabContent from './ModelsTabContent';
import PromptsTabContent from './PromptsTabContent';
import EmbeddingsTabContent from './EmbeddingsTabContent';
import AdvancedTabContent from './AdvancedTabContent';

interface AIIntegrationSettingsProps {
  editing: boolean;
  onEditToggle: () => void;
  onSave: () => void;
}

const AIIntegrationSettings: React.FC<AIIntegrationSettingsProps> = ({ 
  editing, 
  onEditToggle, 
  onSave 
}) => {
  const [activeTab, setActiveTab] = useState("models");
  const [temperature, setTemperature] = useState(0.7);
  
  return (
    <Card>
      <AISettingsHeader 
        editing={editing}
        onEditToggle={onEditToggle}
        onSave={onSave}
      />
      
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full p-6 pt-0 space-y-6">
        <TabsList className="grid grid-cols-4 mb-6">
          <TabsTrigger value="models">Models</TabsTrigger>
          <TabsTrigger value="prompts">Prompts</TabsTrigger>
          <TabsTrigger value="embeddings">Embeddings</TabsTrigger>
          <TabsTrigger value="advanced">Advanced</TabsTrigger>
        </TabsList>
        
        <TabsContent value="models">
          <ModelsTabContent 
            editing={editing} 
            temperature={temperature}
            setTemperature={setTemperature}
          />
        </TabsContent>
        
        <TabsContent value="prompts">
          <PromptsTabContent editing={editing} />
        </TabsContent>
        
        <TabsContent value="embeddings">
          <EmbeddingsTabContent editing={editing} />
        </TabsContent>
        
        <TabsContent value="advanced">
          <AdvancedTabContent editing={editing} />
        </TabsContent>
        
        {!editing && (
          <div className="flex justify-center items-center mt-6">
            <Button variant="default" className="gap-2">
              <Zap className="h-4 w-4" />
              Test AI Connection
            </Button>
          </div>
        )}
      </Tabs>
    </Card>
  );
};

export default AIIntegrationSettings;
